/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/webapp/js/libs/jquery/ui/1.10/i18n/jquery.ui.datepicker-fr-CA-aa.js
*    TO   --> ./webapps/shared-web/src/main/assets/js/plugins/date-picker/i18n/jquery.ui.datepicker-fr-CA-aa.js
**/

/* Spanish Version of Datepicker regional settings */
jQuery(function($){
	$.datepicker.regional['fr_CA'] = {
			closeText: 'Fermer',
			prevText: 'Pr&eacute;c',
			nextText: 'Suiv',
			currentText: "Aujourd'hui",
			monthNames: ['Janvier ','F&eacute;vrier','Mars','Avril','Mai','Juin',
			'Juillet','Ao&ucirc;t','Septembre','Octobre','Novembre','D&eacute;cembre'],
			monthNamesShort: ['Jan','F&eacute;v','Mar','Avr','Mai','Jui',
			'Jui','Ao&ucirc;','Sep','Oct','Nov','D&eacute;c'],
			dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
			dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
			dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
			weekHeader: 'Wk',
			dateFormat: 'dd/mm/yy',
			firstDay: 1,
			isRTL: false,
			showMonthAfterYear: false,
			yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['fr_CA']);
});
